import { gql } from 'apollo-angular';

export const GET_SERVICES = gql`
  query services($search: String) {
    services(search: $search) {
      id
      branchId
      branchData {
        id
        branchName
      }
      serviceName
      serviceCode
      description
    }
  }
`;

export const GET_SERVICE_DROPDOWN = gql`
  query serviceDropDown($search: String) {
    serviceDropDown(search: $search) {
      id
      serviceName
      serviceCode
      totalPrice
    }
  }
`;

export const GET_SERVICE_BY_ID = gql`
  query service($id: Int!) {
    service(id: $id) {
      id
      branchId
      branchData {
        id
        branchName
      }
      serviceTasks {
        id
        taskId
        serviceId
        isMandatory
        sequenceOrder
        taskData {
          id
          taskName
        }
      }
      serviceName
      serviceCode
      description
    }
  }
`;
